module.exports = __webpack_public_path__ + "static/media/Howard, Burlingame, CA6.07c43e04.jpg";